var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateButtonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 28C21.9558 28 28 21.9558 28 14.5C28 7.04416 21.9558 1 14.5 1C7.04416 1 1 7.04416 1 14.5C1 21.9558 7.04416 28 14.5 28Z",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 13.5H18.5C19.0523 13.5 19.5 13.9477 19.5 14.5C19.5 15.0523 19.0523 15.5 18.5 15.5H15.5V18.5C15.5 19.0523 15.0523 19.5 14.5 19.5C13.9477 19.5 13.5 19.0523 13.5 18.5V15.5H10.5C9.94772 15.5 9.5 15.0523 9.5 14.5C9.5 13.9477 9.94772 13.5 10.5 13.5H13.5V10.5C13.5 9.94772 13.9477 9.5 14.5 9.5C15.0523 9.5 15.5 9.94772 15.5 10.5V13.5Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateButtonIcon);
export default __webpack_public_path__ + "static/media/create-button-icon.6815a3c7347bbdbb7ae682b08dbdfb4a.svg";
export { ForwardRef as ReactComponent };